// Ses bildirim yardımcısı - Web Audio API ile programatik "ping" sesi üretir
// Böylece dış ses dosyası gerektirmez ve her tarayıcıda çalışır

let audioCtx = null;

const getAudioContext = () => {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  // Autoplay policy: resume on user interaction
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
};

/**
 * Zarif iki-notalı bildirim sesi (E5 -> A5, marimba benzeri)
 * @param {'customer'|'admin'} variant - Farklı roller için farklı ton
 */
export const playNotifySound = (variant = 'customer') => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    const now = ctx.currentTime;
    // Frequencies: admin (higher pitched, brighter) vs customer (softer)
    const notes = variant === 'admin'
      ? [880, 1174.66]        // A5, D6
      : [659.25, 987.77];     // E5, B5

    notes.forEach((freq, i) => {
      const t = now + i * 0.14;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, t);
      // Envelope: sharp attack, exponential decay
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.18, t + 0.005);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.4);
    });
  } catch (e) {
    // Ses çalınamadıysa sessizce geç (autoplay policy)
  }
};

/**
 * Kullanıcı ilk kez ile etkileşime girdiğinde audio context'i "unlock" eder.
 * Bu, tarayıcının autoplay engelini aşmak için bir kez tetiklenir.
 */
export const initAudio = () => {
  const unlock = () => {
    const ctx = getAudioContext();
    if (ctx && ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    document.removeEventListener('click', unlock);
    document.removeEventListener('touchstart', unlock);
    document.removeEventListener('keydown', unlock);
  };
  document.addEventListener('click', unlock, { once: true });
  document.addEventListener('touchstart', unlock, { once: true });
  document.addEventListener('keydown', unlock, { once: true });
};
